import { Theme } from "../../../components/constants";

export default {
    errorMessage: {
        fontSize: "16px", 
        lineHeight: "20px", 
        color: Theme.ERROR_TEXT
    },
    mainContainer: {
        display: 'flex', 
        padding: '80px 20px'
    },
    formContainer: {
        flex: 0.5, 
        display: 'flex', 
        gap: '50px', 
        flexDirection: 'column'
    },
    formFieldRow: {
        display: 'flex', 
        gap: '60px'
    },
    formFieldContainer: {
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '20px'
    },
    emailInputRow: {
        display: 'flex', 
        alignItems: 'center'
    },
    formInputRow: {
        display: "flex", 
        gap: '30px'
    },
    flexOne: {
        flex: 1
    },
    buttonRows: {
        display: 'flex', 
        gap: '20px'
    },
    buttonPadding: {
        padding: '10px 20px'
    },
    cursorDefault: {
        cursor: 'default'
    },
    rightPadding: {
        paddingRight: '10px'
    },
    heightFull: {
        height: '100%',
    },
    flexCol: {
        display: 'flex', 
        justifyContent: 'space-between', 
        flexDirection: 'column'
    }
}